var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReelsVideoSlider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 133,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 133,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 133,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 133,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 133,
    width: 15,
    height: 5,
    fill: "#4C6170"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 23H115V123H55V23ZM63 28H68.791V34H63V28ZM81.8209 28H76.0299V34H81.8209V28ZM89.0597 28H94.8508V34H89.0597V28ZM107.881 28H102.09V34H107.881V28ZM63 112H68.791V118H63V112ZM81.8209 112H76.0299V118H81.8209V112ZM89.0597 112H94.8508V118H89.0597V112ZM107.881 112H102.09V118H107.881V112Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 23H190V123H130V23ZM138 28H143.791V34H138V28ZM156.821 28H151.03V34H156.821V28ZM164.06 28H169.851V34H164.06V28ZM182.881 28H177.09V34H182.881V28ZM138 112H143.791V118H138V112ZM156.821 112H151.03V118H156.821V112ZM164.06 112H169.851V118H164.06V112ZM182.881 112H177.09V118H182.881V112Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205 23H265V123H205V23ZM213 28H218.791V34H213V28ZM231.821 28H226.03V34H231.821V28ZM239.06 28H244.851V34H239.06V28ZM257.881 28H252.09V34H257.881V28ZM213 112H218.791V118H213V112ZM231.821 112H226.03V118H231.821V112ZM239.06 112H244.851V118H239.06V112ZM257.881 112H252.09V118H257.881V112Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98 71L76 87L76 55L98 71Z",
    fill: "#4C6170"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173 71L151 87L151 55L173 71Z",
    fill: "#4C6170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248 71L226 87L226 55L248 71Z",
    fill: "#4C6170"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#9B1926"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelsVideoSlider);
export default __webpack_public_path__ + "static/media/reels_video_slider.5f7d410b566798396dc7168f80d5fe71.svg";
export { ForwardRef as ReactComponent };